/**
 * Moduł zamykania modala
 *
 * @export
 * @class ModalCloseModule
 */
export class ModalCloseModule {
  /**
   * Stan modułu
   *
   * @memberof ModalCloseModule
   */
  public state = {
    show: false,
    confirm: false
  };

  public mutations = {
    /**
     * Ukrywa okienko z potwierdzeniem zamkięcia modala
     *
     * @param localState stan lokalny
     */
    hideConfirmDialog: (localState: any): void => {
      localState.show = false;
    },
    /**
     * Pokazuje okienko z potwierdzeniem zamknięcia modala
     *
     * @param localState stan lokalny
     */
    showConfirmDialog(localState: any): void {
      localState.show = true;
    },
    /**
     * Potwierdza zamknięcie modala
     *
     * @param localState stan lokalny
     */
    confirm(localState: any): void {
      localState.confirm = true;
    },
    /**
     * Resetuje stan potwierdzenia
     *
     * @param localState stan lokalny
     */
    resetConfirmState(localState: any): void {
      localState.confirm = false;
    }
  };

  public actions = {
    /**
     * Wyświetla potwierdzenie zamknięcia modala
     *
     * @param context context
     */
    showConfirmDialog(context: any): void {
      context.commit('showConfirmDialog');
    },
    /**
     * Ukrywa potwierdzenie zamknięcia modala
     *
     * @param context context
     */
    hideConfirmDialog(context: any): void {
      context.commit('hideConfirmDialog');
    },
    /**
     * Potwierdza zamknięcie modala
     *
     * @param context context
     */
    confirm(context: any): void {
      context.commit('confirm');
    },
    /**
     * Resetuje stan potwierdzenia
     *
     * @param context context
     */
    resetConfirmState(context: any): void {
      context.commit('resetConfirmState');
    }
  };
}

export default new ModalCloseModule();
